import { UserManager } from 'oidc-client';
import { storeUserError, storeUser } from '../redux/actions/authAction';
import {
  IDENTITY_AUTHORITY,
  IDENTITY_CLIENT_ID,
  IDENTITY_REDIRECT_URI,
  IDENTITY_LOGOUT_REDIRECT_URI,
  IDENTITY_ACCESS_TOKEN_EXPIRING_NOTIFICATION_TIME,
  IDENTITY_SILENT_REDIRECT_URI,
  IDENTITY_SCOPE,
} from '../constants/authConstants';
import store from '../redux/store';
import setAuthHeader from './axiosService';

const IDENTITY_CONFIG = {
  authority: IDENTITY_AUTHORITY,
  client_id: IDENTITY_CLIENT_ID,
  redirect_uri: IDENTITY_REDIRECT_URI,
  response_type: 'code',
  scope: IDENTITY_SCOPE,
  post_logout_redirect_uri: IDENTITY_LOGOUT_REDIRECT_URI,
  // Controle da renovação de token automática
  automaticSilentRenew: false,
  silent_redirect_uri: IDENTITY_SILENT_REDIRECT_URI,
  // Tempo (em segundos) antes do token expirar para notificar o usuário
  accessTokenExpiringNotificationTime: IDENTITY_ACCESS_TOKEN_EXPIRING_NOTIFICATION_TIME,
};

export const userManager = new UserManager(IDENTITY_CONFIG);

// export const getIdentityAcessTokenExpiringTime = tokenExpireTimeLeft => tokenExpireTimeLeft;

export async function loadUserFromStorage() {
  // store
  try {
    const user = await userManager.getUser();

    if (!user) {
      return store.dispatch(storeUserError());
    }

    // getIdentityAcessTokenExpiringTime(user.expires_in);

    // Salva token no header para cada requisição
    setAuthHeader(user.access_token);

    // Restringe dados do usuário a serem guardados
    const userData = {
      sub: user.profile.sub,
      name: user.profile.name,
      given_name: user.profile.given_name,
      role: user.profile.role,
      preferred_username: user.profile.preferred_username,
      // expire: user.expires_in, // Tempo até o token expirar
    };

    return store.dispatch(storeUser(userData));
  } catch (e) {
    console.error(`User not found: ${e}`);
    return store.dispatch(storeUserError());
  }
}

export const signinRedirect = () => userManager.signinRedirect();

export const signinRedirectCallback = () => userManager.signinRedirectCallback();

export const signoutRedirect = () => {
  userManager.getUser().then((user) => {
    userManager.clearStaleState();
    userManager.removeUser();

    return userManager.signoutRedirect({ id_token_hint: user.id_token });
  });
};

export const signoutRedirectCallback = () => {
  userManager.getUser().then((user) => {
    userManager.clearStaleState();
    userManager.removeUser();
    return userManager.signoutRedirectCallback({ id_token_hint: user.id_token });
  });
};

export const signinSilent = () => userManager.signinSilent();

export const signinSilentCallback = () => userManager.signinSilentCallback();
